export const VIDEO_PLAYBACK_STATE_NAME: string = 'portal.video';
export const VIDEO_PLAYLIST_PLAYBACK_STATE_NAME: string = 'portal.video-playlist-playback';
export const PUBLIC_VIDEO_PASSWORD_STATE_NAME = 'portal.public-video-password';
export const VIDEO_SETTINGS_STATE_NAME = 'portal.video-settings';
